import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <section id="about" className="py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative h-[600px] rounded-lg overflow-hidden">
            <img 
              src="https://static.wixstatic.com/media/b85534_cc3439f64ac14034ade1540063ba0c50~mv2.jpg"
              alt="Red Light Therapy Room"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content */}
          <div>
            <h2 className="font-serif text-4xl md:text-5xl font-light text-gray-900 mb-8">
              Our Vision and Purpose
            </h2>

            <div className="space-y-6">
              <div>
                <h3 className="font-serif text-2xl font-medium text-gray-900 mb-3">Who We Are</h3>
                <p className="text-gray-700 leading-relaxed">
                  At NovaRadiance Distribution L.L.C., we are dedicated to enhancing quality of life through advanced light therapy solutions. We bridge the gap between China's leading manufacturers and the American market, providing you with the advantage of working within your time zone with no language barriers.
                </p>
              </div>

              <div>
                <h3 className="font-serif text-2xl font-medium text-gray-900 mb-3">What We Offer</h3>
                <p className="text-gray-700 leading-relaxed">
                  Specializing in infrared light beds, redlight masks, and panels, we focus on educating customers regarding the profound advantages of infrared technology over traditional options. Our products are manufactured in ISO-certified facilities with rigorous quality control, ensuring the highest standards of safety and effectiveness.
                </p>
              </div>

              <div>
                <h3 className="font-serif text-2xl font-medium text-gray-900 mb-3">Why Choose Us</h3>
                <p className="text-gray-700 leading-relaxed">
                  As your US-based partner, we eliminate the complexities of international sourcing. Enjoy seamless communication, reliable support, and expert guidance—all in your time zone. We provide comprehensive support including installation training, marketing materials, and long-term buyback agreements, ensuring you're valued and well-informed throughout your journey.
                </p>
              </div>

              <Link 
                to="/about"
                className="inline-block bg-gray-900 text-white px-8 py-3 rounded-md text-sm font-medium hover:bg-gray-800 transition-colors mt-4 cursor-pointer whitespace-nowrap"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
